import axios from 'axios';

const http = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://messe-admin.meyle.com'
      : 'http://127.0.0.1:8010',

  withCredentials: true
});

export default http;
